import React, { Fragment } from 'react'
import { Navbar } from './navbar/Navbar';
import './Layout.module.css'

export const Layout = ({ children }) => {
  return (

    <Fragment>
      <Navbar />
      <main className='mainWrapper'>
        {children}
      </main>
    </Fragment>

  );
};



// WEBPACK FOOTER //
// ./src/layout/Layout.jsx